const map = {
	"./$.png": 39421,
	"./calendar.png": 60743,
	"./chain.png": 52646,
	"./clock.png": 62743,
	"./docs.png": 3132,
	"./earth.png": 31865,
	"./new-icon/Attendance Management 1.png": 73563,
	"./new-icon/Block Chain 1.png": 35089,
	"./new-icon/Digital Noticeboard 1.png": 53509,
	"./new-icon/Domain Customization 1.png": 94876,
	"./new-icon/Employee Management 1.png": 11808,
	"./new-icon/Leave Management 1.png": 14493,
	"./new-icon/Notification Center 1.png": 46897,
	"./new-icon/Payroll Management 1.png": 97515,
	"./new-icon/Shift Management 1.png": 35622,
	"./new-icon/Tax Management 1.png": 82811,
	"./notification.png": 86952,
	"./smartPeople.png": 92583,
	"./status.png": 49543,
	"./timeline.png": 59288,
	"./user.png": 64084
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32265;